        <template>
        <form :data-vv-scope="scopeName">
            <div v-for="(input, index) in value">
					<div class="width-100 mdc-textfield mdc-textfield--upgraded">
						<!-- Without v-focus -->
                 <input v-if="index === 0"
					  	  class="mdc-textfield__input"
                    v-validate="rules"
						  data-vv-delay="500"
                    :type="type"
                    :name="name+index"
                    :placeholder="''"
                    :inputmode="inputmode"
                    :value="input"
                    @input="update(index, $event)"></input>

  				  		<!-- With v-focus -->
					  <input v-else
					     class="mdc-textfield__input"
                    v-validate="rules"
						  data-vv-delay="500"
                    :type="type"
                    :name="name+index"
                    :placeholder="''"
                    :inputmode="inputmode"
                    :value="input"
                    @input="update(index, $event)"
                    v-focus></input>

						  <label class="mdc-textfield__label mdc-textfield__label--float-above">{{ placeholder }}</label>
                    <a v-if="index > 0" href="#" class="input__closebtn" @click.prevent="remove(index)"><img :src="'/svg/'+imageLink+'.svg'"></a>
					</div>
					<span v-show="errors.has(name+index, scopeName)" class="input__error">{{ removeNumbers(errors.first(name+index, scopeName)) }}</span>
            </div>

            <a v-if="!errors.has(name+(inputs.length-1), scopeName) && inputs[inputs.length-1] != ''" class="add-link" href="#" v-on:click.prevent="add">Add another {{linkName}}</a>


        </form>
        </template>

        <script>
            export default {
                inject: ['$validator'],

                props: {
                    value: {
                        type: Array,
                        default: ['']
                    },
                    rules: [String, Object],
                    type: {
                        type:       String,
                        default:    "text"
                    },

                    name:           String,
                    placeholder:    String,
                    inputmode:      String,

                    linkName: {
                        type:       String,
                        default:    "input"
                    },
						  imageLink: {
							  type:			String,
							  default: 		"TrashCan"
						  },
						  scopeName: String
                },

                data: function () {
                    return {
                        inputs: this.value
                    }
                },
					 computed: {

					 },
                methods: {
                    add: function () {
                        this.inputs.push('');
                    },

                    update: function(index, e) {
								this.inputs.splice(index, 1, e.target.value);
								this.hasErrors();
                        this.$emit('input', this.inputs);
                    },
                    remove: function(index) {
                        if (this.inputs.length > 1) {
                            this.inputs.splice(index, 1);
                            this.$emit('input', this.inputs);
                        }
                    },
						  removeNumbers: function(phrase) {
							  if (phrase != null && phrase != '') {
								  return phrase.replace(/[0-9]/g, '');
							  }
 						 },
						 hasErrors: function() {
							 var self = this
							 if (this.scopeName !== undefined) {
								 this.$validator.validateAll(this.scopeName).then(function(result) {
				 					 self.$emit('hasErrors', !result)
				 				});
							}
						 }
                }
            }
        </script>

        <style scoped>
		  		form {
					margin-bottom: 0;
				}

            .add-link {
                text-align: center;
					 display: block;
            }

				img {
					width: 17px;
					height: 17px;
				}

        </style>
